import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { AppMenu } from '../../api/models';

export type TABLE_TYPE = Table<AppMenu>;

export const TABLE = 'appMenu';
const SCHEMA = 'appMenuId';

class AppMenuDatabase implements DataRepository<AppMenu> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<AppMenu | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: AppMenu, key: Key): Promise<AppMenu> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: AppMenu[]): Promise<AppMenu[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<AppMenu[]> {
    return this.db[TABLE].toArray();
  }
}

export const AppMenuDB = new AppMenuDatabase(db);
